import React, { FC } from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ContentfulRichTextGatsbyReference, renderRichText, RenderRichTextData } from 'gatsby-source-contentful/rich-text'
import styleClasses from './contentful-richtext.module.scss'

export type ContentfulRichTextProps = {
  richText?: GatsbyTypes.ContentfulContentRichText
}

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node: any) => {
      // eslint-disable-next-line react/destructuring-assignment
      const file = node.data.target.fields.file['en-US']
      // eslint-disable-next-line react/destructuring-assignment
      const alt = node.data.target.fields.title['en-US']
      return (
        <img alt={alt} src={file.url} className={styleClasses.img} width={file.details.image.width} height={file.details.image.height} />
      )
    },
  },
}

const ContentfulRichText: FC<ContentfulRichTextProps> = ({ richText }) => {
  return richText ? <>{renderRichText(richText as RenderRichTextData<ContentfulRichTextGatsbyReference>, options)}</> : null
  return <h1>RICH_TEXT_RENDERER</h1>
}

export default ContentfulRichText
